import { render, staticRenderFns } from "./AwsMailIntegration.vue?vue&type=template&id=bc482482&scoped=true"
import script from "./AwsMailIntegration.vue?vue&type=script&lang=js"
export * from "./AwsMailIntegration.vue?vue&type=script&lang=js"
import style0 from "./AwsMailIntegration.vue?vue&type=style&index=0&id=bc482482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc482482",
  null
  
)

export default component.exports